import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.admin');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-layout-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.admin/view.scss */
/* src/app/layout.admin/view.scss: no such file or directory */`],
})
export class LayoutAdminComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default LayoutAdminComponent;